/*
 * Copyright (C) 2025 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and
 * should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly
 * prohibited.
 */

import { FEATURE_FLAGS, isFeatureEnabled } from './FeatureFlagUtils';

/**
 * Determines if the current month is December (Christmas time)
 * @param appConfig - application config containing feature flags
 * @returns true if current month is December and seasonalFunEnabled is true, false otherwise
 */
export const isChristmasTime = (appConfig: any): boolean => {
  const month = new Date().getMonth();
  return isFeatureEnabled(appConfig, FEATURE_FLAGS.seasonalFunEnabled) && month === 11; // December
};
